module.exports = __webpack_public_path__ + "static/media/richmondDinner.2690f27c.pdf";